(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  if (!customElements.get('enhanced-header-nav')) {
    class EnhancedHeaderNav extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        if (window.innerWidth < 990) return;
        this.menuItems = this.querySelectorAll('.list-menu--inline > li');
        this.currentPath = window.location.pathname;
        this.setupHoverBehavior();
        this.markActiveItems();
        this.setupOutsideClose();
        this.reopenAfterNavigation();
      }

      // After a parent label click navigates to its page, re-open that mega menu
      // so the submenu is visible on the destination page.
      reopenAfterNavigation() {
        let reopenId;
        try { reopenId = sessionStorage.getItem('rf-megamenu-open'); } catch (e) { return; }
        if (!reopenId) return;
        try { sessionStorage.removeItem('rf-megamenu-open'); } catch (e) {}
        const summary = document.getElementById(reopenId);
        const details = summary && summary.closest('details');
        if (details) details.setAttribute('open', '');
      }

      // Close any open mega menu when clicking anywhere outside the header nav.
      setupOutsideClose() {
        if (EnhancedHeaderNav._outsideBound) return;
        EnhancedHeaderNav._outsideBound = true;
        document.addEventListener('click', (e) => {
          if (e.target.closest('header-menu')) return;
          document
            .querySelectorAll('.header__inline-menu details[open]')
            .forEach((d) => d.removeAttribute('open'));
        });
      }

      setupHoverBehavior() {
        this.menuItems.forEach(item => {
          const headerMenu = item.querySelector('header-menu');
          if (!headerMenu) return;
          const details = headerMenu.querySelector('details');
          if (!details) return;
          let hoverTimeout;
          let isOverMenu = false;
          let isOverSubmenu = false;
          const openMenu = () => {
            clearTimeout(hoverTimeout);
            details.setAttribute('open', '');
          };
          const closeMenu = () => {
            hoverTimeout = setTimeout(() => {
              if (!isOverMenu && !isOverSubmenu) {
                details.removeAttribute('open');
              }
            }, 150);
          };
          item.addEventListener('mouseenter', () => {
            isOverMenu = true;
            clearTimeout(hoverTimeout);
            hoverTimeout = setTimeout(openMenu, 100);
          });
          item.addEventListener('mouseleave', () => {
            isOverMenu = false;
            closeMenu();
          });
          const submenu = details.querySelector('.mega-menu__content');
          if (submenu) {
            submenu.addEventListener('mouseenter', () => {
              isOverSubmenu = true;
              clearTimeout(hoverTimeout);
            });
            submenu.addEventListener('mouseleave', () => {
              isOverSubmenu = false;
              closeMenu();
            });
          }
          const summary = details.querySelector('summary');
          if (summary) {
            summary.addEventListener('click', (e) => {
              if (window.innerWidth < 990) return;
              // Desktop: clicking a parent label navigates to its page. Remember
              // which menu to re-open once the destination page has loaded, so the
              // submenu is shown (vuori-style) rather than vanishing on reload.
              e.preventDefault();
              const url = summary.dataset.linkUrl;
              if (url && url !== '#' && url !== '') {
                try { sessionStorage.setItem('rf-megamenu-open', summary.id); } catch (err) {}
                window.location.href = url;
              } else {
                details.toggleAttribute('open');
              }
            });
          }
        });
      }

      markActiveItems() {
        this.menuItems.forEach(item => {
          const link = item.querySelector('a');
          if (!link) return;
          const href = link.getAttribute('href');
          if (this.isActivePath(href)) {
            item.classList.add('menu-item--active');
          }
          const submenuLinks = item.querySelectorAll('.mega-menu__content a');
          submenuLinks.forEach(subLink => {
            const subHref = subLink.getAttribute('href');
            if (this.isActivePath(subHref)) {
              item.classList.add('menu-item--active');
              subLink.closest('li')?.classList.add('menu-item--active');
            }
          });
        });
      }

      isActivePath(href) {
        if (!href || href === '#') return false;
        const cleanHref = href.replace(/\/$/, '');
        const cleanPath = this.currentPath.replace(/\/$/, '');
        if (cleanHref === cleanPath) return true;
        if (cleanPath.startsWith(cleanHref + '/') && cleanHref !== '') {
          return true;
        }
        return false;
      }
    }
    customElements.define('enhanced-header-nav', EnhancedHeaderNav);
  }

  document.addEventListener('DOMContentLoaded', () => {
    const enhancedNav = document.querySelector('enhanced-header-nav[data-enhanced-nav="true"]');
    if (enhancedNav && !enhancedNav.initialized) {
      enhancedNav.initialized = true;
    }
  });

  document.addEventListener('shopify:section:load', (event) => {
    if (event.detail.sectionId.includes('header')) {
      setTimeout(() => {
        const nav = document.querySelector('enhanced-header-nav');
        if (nav) {
          const instance = new EnhancedHeaderNav();
          instance.init.call(nav);
        }
      }, 100);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
